import { cacheConfig, CustomAxiosRequestConfig, http } from '../helpers/axiosHelper';

const skipErrorNotificationConfig = { skipErrorNotification: true } as CustomAxiosRequestConfig;

export default class PropertyService {
   async getProperties(journeyId?: number | string) {
      const params: Record<string, string | number> = { include: 'moduleTypes,propertyEntriesCount' };
      if (journeyId !== undefined) {
         params.journey_id = journeyId;
      }

      return http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/property', {
            ...cacheConfig,
            params,
         })
         .then((response) => {
            return response.data;
         });
   }

   async createProperty(body: { name: string; journey_id: number | string; module_type_ids?: number[] }) {
      const config: CustomAxiosRequestConfig = { ...skipErrorNotificationConfig, params: { include: 'moduleTypes' } };

      return http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/property', body, config).then((response) => {
         return response.data;
      });
   }

   async updateProperty(id: number | string, body: { name: string }) {
      return http
         .put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/property/' + id, body, skipErrorNotificationConfig)
         .then((response) => {
            return response.data;
         });
   }

   async deleteProperty(id: number | string) {
      return http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/property/' + id, skipErrorNotificationConfig).then((response) => {
         return response.data;
      });
   }
}
